import { safeJson } from "@/lib/http";
import { supabase } from "@/lib/supabase";

const BASE = process.env.REACT_APP_BACKEND_URL;

async function token() {
    const { data } = await supabase.auth.getSession();
    const t = data.session?.access_token;
    if (!t) throw new Error("Session expirée, reconnectez-vous.");
    return t;
}

async function call(path, method = "GET") {
    const r = await fetch(`${BASE}${path}`, { method, headers: { Authorization: `Bearer ${await token()}` } });
    const j = await safeJson(r);
    if (!r.ok) throw new Error(typeof j.detail === "string" ? j.detail : `Erreur ${r.status}`);
    return j;
}

async function callBody(path, method, body) {
    const r = await fetch(`${BASE}${path}`, { method, headers: { Authorization: `Bearer ${await token()}`, "Content-Type": "application/json" }, body: JSON.stringify(body || {}) });
    const j = await safeJson(r);
    if (!r.ok) throw new Error(typeof j.detail === "string" ? j.detail : `Erreur ${r.status}`);
    return j;
}

export const startScan = (id) => call(`/api/forensic/dossiers/${id}/scan/jobs`, "POST");
export const fetchScanJob = (id, job) => call(`/api/forensic/dossiers/${id}/scan/jobs/${job}`);
export const fetchLastScan = (id) => call(`/api/forensic/dossiers/${id}/scan`);
export const startAudit = (id) => call(`/api/forensic/dossiers/${id}/audit/jobs`, "POST");
export const fetchAuditJob = (id, job) => call(`/api/forensic/dossiers/${id}/audit/jobs/${job}`);
export const fetchLastAudit = (id) => call(`/api/forensic/dossiers/${id}/audit`);

export const startSynthese = (id, instructions) => callBody(`/api/forensic/dossiers/${id}/synthese/jobs`, "POST", { instructions: instructions || "" });
export const fetchSyntheseJob = (id, job) => call(`/api/forensic/dossiers/${id}/synthese/jobs/${job}`);
export const fetchLastSynthese = (id) => call(`/api/forensic/dossiers/${id}/synthese`);

export const fetchForensicParams = (id) => call(`/api/forensic/dossiers/${id}/params`);
export const educateForensic = (id, message) => callBody(`/api/forensic/dossiers/${id}/education`, "POST", { message });
export async function saveForensicParams(id, patch) {
    const r = await fetch(`${BASE}/api/forensic/dossiers/${id}/params`, { method: "PATCH", headers: { Authorization: `Bearer ${await token()}`, "Content-Type": "application/json" }, body: JSON.stringify(patch) });
    if (!r.ok) throw new Error((await r.json().catch(() => ({}))).detail || `Erreur ${r.status}`);
    return r.json();
}
export async function downloadAnomaliesXlsx(id) {
    const r = await fetch(`${BASE}/api/forensic/dossiers/${id}/export.xlsx`, { headers: { Authorization: `Bearer ${await token()}` } });
    if (!r.ok) throw new Error((await r.json().catch(() => ({}))).detail || `Erreur ${r.status}`);
    const url = URL.createObjectURL(await r.blob());
    const a = Object.assign(document.createElement("a"), { href: url, download: "anomalies_fec_a_reclasser.xlsx" });
    a.click(); URL.revokeObjectURL(url);
}

export async function downloadAuditPdf(id) {
    const r = await fetch(`${BASE}/api/forensic/dossiers/${id}/audit/pdf`, { headers: { Authorization: `Bearer ${await token()}` } });
    if (!r.ok) { const j = await safeJson(r); throw new Error(typeof j.detail === "string" ? j.detail : `Erreur ${r.status}`); }
    const blob = await r.blob();
    const name = (r.headers.get("Content-Disposition") || "").match(/filename="([^"]+)"/)?.[1] || "Audit_Fiabilite.pdf";
    const url = URL.createObjectURL(blob);
    Object.assign(document.createElement("a"), { href: url, download: name }).click();
    URL.revokeObjectURL(url);
}

export async function pollJob(fetchFn, onTick, ms = 3000, onLost) {
    let lost = 0;
    for (;;) {
        await new Promise((r) => setTimeout(r, ms));
        let j;
        try {
            j = await fetchFn();
        } catch (e) {
            if (/introuvable|indisponible|Erreur 5\d\d/i.test(e.message) && lost++ < 4) {
                if (onLost) { const recovered = await onLost().catch(() => null); if (recovered) return recovered; }
                continue;
            }
            throw e;
        }
        onTick?.(j);
        if (j.stage === "done") return j;
        if (j.stage === "error") throw new Error(String(j.error || "Erreur"));
    }
}
